import psl_ui from '../../libs/psl_ui.js';

import template from './template.pst';

import './style.scss';

psl_ui.templates.add('component_nav',template);

const {el}=psl_ui.templates.render('component_nav');

const _skip = el.querySelector('.skip');

let _clb;

el.querySelectorAll('button').forEach(btn=>btn.addEventListener('click',()=>{
	if(_clb) _clb(btn.parentNode.className.replace('btn_container ',''));
}));

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/1080;
		height=height/1920;
	}

	coef = Math.min(width,height);

	el.style.transform=`scale3d(${coef},${coef},1)`;

	Array.from(el.querySelectorAll('label')).forEach(label=>{
		label.style.top=-12/coef+'px';
		label.style.transform=`scale3d(${1/coef},${1/coef},1)`;
	});
}

_resize();

export default {
	get clb(){
		return _clb;
	},
	set clb(clb){
		_clb=clb;
	},
	view:el,
	set skip(v){
		if(v){
			if(!_skip.parentNode) el.insertBefore(_skip,el.childNodes[0]);
		} else if(_skip.parentNode) _skip.parentNode.removeChild(_skip);
	},
	get skip(){
		return !!_skip.parentNode;
	}
}
